module.exports = __webpack_public_path__ + "static/media/camera_shutter.ce1581e5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/camera_shutter.mp3
// module id = 1541
// module chunks = 0